import { useState, useEffect } from 'react';

/**
 * Detects iOS virtual keyboard presence via the visualViewport API.
 * Returns true when the keyboard is up (viewport height shrinks significantly).
 * Falls back to false on browsers without visualViewport support.
 */
export function useKeyboardVisible(): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const threshold = 150; // keyboard is at least ~150px tall

    const onResize = () => {
      const diff = window.innerHeight - vv.height;
      setVisible(diff > threshold);
    };

    vv.addEventListener('resize', onResize);
    return () => vv.removeEventListener('resize', onResize);
  }, []);

  return visible;
}
